/* eslint-disable no-param-reassign */
import qs from 'qs'
import { useTenantStore } from '@/store'
import { platform } from '@/utils/platform'
import { isLaunchFinished } from '@/utils/common'

export type CustomRequestOptions = UniApp.RequestOptions & {
  query?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

// 请求基准地址
// h5会跨域
// const baseUrl = import.meta.env.VITE_SERVER_BASEURL
// h5不会跨域
let baseUrl
// #ifdef WEB
baseUrl = import.meta.env.VITE_APP_PROXY_PREFIX
// #endif
// #ifndef WEB
baseUrl = import.meta.env.VITE_SERVER_BASEURL
// #endif
// 等待启动参数获取完成
async function waitLaunchFinished() {
  return new Promise((resolve) => {
    if (isLaunchFinished.value) {
      resolve(true)
    } else {
      const stop = watch(
        () => isLaunchFinished.value,
        (val) => {
          if (val) {
            stop() // 停止监听
            resolve(true)
          }
        },
      )
    }
  })
}

// 这里的代码会在 Promise 完成后执行
let tenantId = null

/**
 * 同步补齐请求参数。
 * uni-app 会监听拦截器的返回值：invoke 返回 Promise 时，任务型 API（uploadFile / downloadFile）
 * 的返回值会从 UploadTask 变成 Promise，调用方无法再调用 onProgressUpdate / abort。
 */
function prepareOptions(options: CustomRequestOptions) {
  if (!tenantId) {
    // const launchOptions = uni.getLaunchOptionsSync()
    // const launchQuery = launchOptions.query
    // tenantId = launchQuery.tenant_id
    const tenantStore = useTenantStore()
    tenantId = tenantStore.getTenantData('tenantId')
  }
  // 接口请求支持通过 query 参数配置 queryString
  if (options.query) {
    const queryStr = qs.stringify(options.query)
    if (options.url.includes('?')) {
      options.url += `&${queryStr}`
    } else {
      options.url += `?${queryStr}`
    }
  }

  // 非 http 开头需拼接地址
  if (!options.url.startsWith('http')) {
    options.url = baseUrl + options.url
  }

  // 判断是否是文件上传
  const isUploadFile = !!options.files || !!options.filePath

  // 根据是否为上传文件请求设置不同的超时时间
  if (isUploadFile) {
    // 文件上传请求设置较长的超时时间，
    options.timeout = 50000 // 50s
  } else {
    // 普通请求设置较短的超时时间，
    options.timeout = 30000 // 3s
  }

  // 添加小程序端请求头标识
  options.header = {
    platform, // 可选，与 uniapp 定义的平台一致，告诉后台来源
    'tenant-id': tenantId,
    ...options.header,
  }
  // 添加 token 请求头标识
  // 添加 Token 到请求头
  const { getToken } = useTokenUtils()
  const token = getToken()
  if (token) {
    options.header.Authorization = `Bearer ${token}`
  }
  return options
}

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发。启动完成后必须同步返回 options，否则 uni.uploadFile 会退化为 Promise。
  invoke: (options: CustomRequestOptions) => {
    if (!isLaunchFinished.value) {
      return waitLaunchFinished().then(() => prepareOptions(options))
    }
    return prepareOptions(options)
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
